module.exports = {" ":" ","weather_same":"어제와 온도가\n 같습니다.","weather_lower":"어제보다\n {temp} 낮습니다.","weather_higher":"어제보다\n {temp} 높습니다.","weather_beforeText":"","aqi_title":"외부 공기질 (AQI)","aqi_index_0":"로딩 중…","aqi_index_1":"좋음","aqi_index_2":"보통","aqi_index_3":"주의","aqi_index_4":"나쁨","aqi_index_5":"매우 나쁨","aqi_index_6":"위험","aqi_noData":"최근 데이터 없음","monthLocale":"ko-KR","location":"서울특별시 강남구 테헤란로","awair_score":"어웨어 스코어","good":"좋음","fair":"보통","poor":"나쁨","disconnected":"-","temp":"온도 (°C)","humid":"습도 (%)","co2":"이산화탄소 (ppm)","voc":"화학물질 (ppb)","pm25":"초미세먼지 (µg/m³)"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/ko.json
// module id = 293
// module chunks = 0